exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".green[data-v-65dee732]{color:#077432}.red[data-v-65dee732]{color:#eb5e50}.black[data-v-65dee732]{color:#3b3b3a}.orange[data-v-65dee732]{color:#f5a623}.white[data-v-65dee732]{display:none}.bullet-stock[data-v-65dee732]{display:list-item;list-style-position:inside;list-style-type:disc}", ""]);

